import { render, staticRenderFns } from "./postulacion.vue?vue&type=template&id=1ddcb39e&scoped=true&"
import script from "./postulacion.vue?vue&type=script&lang=js&"
export * from "./postulacion.vue?vue&type=script&lang=js&"
import style0 from "./postulacion.vue?vue&type=style&index=0&id=1ddcb39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcb39e",
  null
  
)

export default component.exports